export default "__VITE_ASSET__DglZOEXn__"